module.exports = {"331083001":"玉城街道","331083002":"坎门街道","331083003":"大麦屿街道","331083101":"清港镇","331083102":"楚门镇","331083103":"干江镇","331083105":"沙门镇","331083106":"芦浦镇","331083107":"龙溪镇","331083201":"鸡山乡","331083202":"海山乡","331083400":"玉环经济开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/331083.json
// module id = 1025
// module chunks = 0